import { Phone, ArrowRight } from 'lucide-react';

export const CTABlock = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#kontakt');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section data-testid="cta-section" className="cta-section py-20 md:py-32 noise-texture">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Eyebrow */}
          <span className="inline-block text-[#E31E24] font-semibold text-sm uppercase tracking-widest mb-6">
            Bereit für Ihr Projekt?
          </span>
          
          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Von der Beratung bis zur Abnahme – 
            <span className="text-[#E31E24]"> in fünf einfachen Schritten</span>
          </h2>
          
          {/* Description */}
          <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto">
            Profitieren Sie von unserer Erfahrung und unserem Know-how. Wir begleiten Sie durch den gesamten Prozess – 
            transparent, zuverlässig und termingerecht.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#kontakt"
              onClick={scrollToContact}
              data-testid="cta-contact-btn"
              className="w-full sm:w-auto bg-[#E31E24] text-white px-8 py-4 font-bold uppercase tracking-wider hover:bg-[#C41217] transition-all duration-300 flex items-center justify-center gap-2 group"
            >
              Jetzt Beratung anfragen
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="tel:020243044510"
              data-testid="cta-phone-btn"
              className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-8 py-4 font-bold uppercase tracking-wider hover:bg-white hover:text-neutral-900 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Direkt anrufen
            </a>
          </div>
          
          {/* Trust Elements */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-white">ISO 9001</div>
              <div className="text-sm text-white/50">Zertifiziert</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">DIN 14675</div>
              <div className="text-sm text-white/50">Fachbetrieb</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">100%</div>
              <div className="text-sm text-white/50">Zufriedenheit</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABlock;
